<template>
    <div>
        <div class="header_unit header_bg_blue">
            <div class="header_box">
                <div class="menu_left">
                    <router-link  :to="{ name: 'dailyCheckMenuIndex' ,
                    params: { menuId: this.menuId, brandPath: $route.params.brandPath }} ">キャンセル</router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_s">{{title}}</p>
                    <p class="menu_center_tex_l">フリーコメント</p>
                </div>
            </div>
        </div>
        <DailyCheckFreeComment :title="title" :menuId="menuId" :subMenuId="subMenuId" :menuNameUpper="menuNameUpper" :menuNameLower="menuNameLower"/>
    </div>
</template>

<script>
    import DailyCheckFreeComment from '@/app/components/DailyCheckFreeComment.vue'

    export default {
        name: 'DailyCheckFreeCommentIndex',
        components: {
            DailyCheckFreeComment
        },
        props:{
            menuId: Number,
            subMenuId: Number,
        },
        computed: {
            menuNameUpper: function () {
                const button = this.$store.getters['buttons/topButton'](this.menuId)
                return 'upperButtonName' in button ? button.upperButtonName : ''
            },
            menuNameLower: function () {
                const button = this.$store.getters['buttons/topButton'](this.menuId)
                return 'lowerButtonName' in button ? button.lowerButtonName : ''
            },
            title: function () {
                const button = this.$store.getters['buttons/dailyCheckButton'](this.menuId, this.subMenuId)
                return 'dailyCheckButtonName' in button ? button.dailyCheckButtonName : ''
            },
        },
    }
</script>
